<script>
import OverlayPageLink from '@/components/OverlayPageLink';

export default {
  name: 'ContentEmergencyButtonBlock',
  components: {
    OverlayPageLink
  },
  props: {
    data: Object
  },
};
</script>

<template>
  <div class="emergency-button">
      <overlay-page-link v-bind:type="'read-more'" v-bind:label="data.label" v-bind:page="data.link" />
  </div>
</template>

<style lang="scss" scoped>
.emergency-button {
    margin: 3.2rem 0 11.2rem;
}
</style>
